import { FallbackProps } from 'react-error-boundary';
import { useIntl } from 'react-intl';

import { EmptyState } from '@/components/ui/empty-state';
import { ErrorState } from '@/components/ui/error-state';

export function NoHiringGoal({ error }: FallbackProps) {
  const intl = useIntl();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (error?.body?.error?.code === 'HIRING_GOAL_NOT_FOUND')
    return (
      <div className="border-fx-neutral-200 flex h-full max-h-full flex-1 gap-8 overflow-hidden rounded-lg border bg-white pb-8">
        <EmptyState
          header={intl.formatMessage({
            defaultMessage: 'View hiring funnel based on goal',
            description:
              'Empty funnel headline: a hiring goal is required to show metrics',
          })}
          description={intl.formatMessage({
            defaultMessage:
              'See the conversion of your workflow stages from application to hire based on your target hires.',
            description:
              'What the funnel will show after the user sets hire targets',
          })}
          buttonTitle={intl.formatMessage({
            defaultMessage: '+ Add hiring goal',
            description:
              'Disabled CTA label until backend supports goal creation (placeholder)',
          })}
          isDisabled
        />
      </div>
    );

  return <ErrorState />;
}
